import { DatePicker, DateTimePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { Box, CircularProgress, Link, Table, Typography } from "@mui/joy";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React from "react";
import { useNavigate } from "react-router-dom";

export default function BrokenElevators() {
	const [dataset, setDataset] = React.useState([] as Array<any>);
	const [fromDate, setFromDate] = React.useState(new Date(new Date().setDate(new Date().getDate() - 90)));
	const [toDate, setToDate] = React.useState(new Date());
	const [loading, setLoading] = React.useState(true);

	const n = useNavigate();

	React.useEffect(() => getData(fromDate, toDate), []);

	const getData = (ft: Date, td: Date) => {
		setLoading(true);
		fetch("Building/GetBrokenElevators", {
			method: "Post",
			headers: {
				"Content-Type": "application/json",
			},
			cache: "no-cache",
			body: JSON.stringify({ FromDate: fromDate, ToDate: toDate }),
		})
			.then((x) => x.json())
			.then((x) => {
				setDataset(x);
				setLoading(false);
			});
	};

	return (
		<>
			<LocalizationProvider dateAdapter={AdapterDateFns}>
				<Box sx={{ overflowY: "auto", padding: 2 }}>
					<Typography level="title-lg" sx={{ marginBottom: 2 }}>
						Broken Elevators
					</Typography>
					<Box>
						<DatePicker
							slotProps={{
								textField: { variant: "standard", size: "small" },
							}}
							label="From Date"
							value={fromDate}
							format="MM/dd/yyyy"
							onChange={(value) => {
								setFromDate(value as Date);
								getData(value as Date, toDate);
							}}
							sx={{ marginRight: 2 }}
						/>
						<DatePicker
							slotProps={{
								textField: { variant: "standard", size: "small" },
							}}
							label="To Date"
							value={toDate}
							format="MM/dd/yyyy"
							onChange={(value) => {
								setToDate(value as Date);
								getData(fromDate, value as Date);
							}}
						/>
					</Box>
					<Table>
						<thead>
							<tr>
								<th>Building</th>
								<th>Serial Number</th>
								<th>Callback Count</th>
							</tr>
						</thead>
						<tbody>
							{loading && (
								<tr>
									<td colSpan={3}>
										<div style={{ display: "flex", flexDirection: "column", width: "100%", alignItems: "center" }}>
											<CircularProgress />
										</div>
									</td>
								</tr>
							)}
							{!loading &&
								dataset.map((x) => (
									<tr>
										<td><Link onClick={() => { n("/buildingportal/" + x.buildings_id) }}>{x.building_name}</Link></td>
										<td>{x.serial_number}</td>
										<td>{x.callbacks}</td>
									</tr>
								))}
						</tbody>
					</Table>
				</Box>
			</LocalizationProvider>
		</>
	);
}
